import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import {
  BsDatepickerConfig,
  BsDatepickerDirective,
  BsLocaleService
} from 'ngx-bootstrap/datepicker';
import { defineLocale, zhCnLocale } from 'ngx-bootstrap/chronos';
import {
  itLocale,
  enGbLocale,
  esLocale,
  frLocale,
  plLocale,
  ptBrLocale,
  deLocale,
  ruLocale,
  nlLocale,
  arLocale
} from 'ngx-bootstrap/locale';
import { CompanyReportService } from 'app/company-report/company-report.service';
import { CoreService } from 'app/shared/services/core.service';
import * as moment from 'moment';

@Component({
  selector: 'app-defer-dialog',
  templateUrl: './defer-dialog.component.html',
  styleUrls: [
    './defer-dialog.component.scss',
    '../../common_styles.scss',
    '../../magic-checkbox.scss'
  ]
})
export class DeferDialogComponent implements OnInit {
  public onClose: Subject<any>;
  objective: any;
  userInfo: any;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  deferralType: string = 'Extend';
  cycleList: any[] = [];
  amsd_settings_cycles: any;
  selectedCycle: any;
  deferDueDate: any;
  isDatePickerOpen: boolean = false;
  newDate = new Date();

  public constructor(
    private _bsModalRef: BsModalRef,
    private localeService: BsLocaleService,
    private companyReportService: CompanyReportService,
    private coreService: CoreService
  ) {}

  public ngOnInit(): void {
    this.onClose = new Subject();
  }

  doSaveDate(e) {
    this.deferDueDate = moment(new Date(e)).format('YYYY-MM-DDThh:mm:ss');
  }

  public showModal(content: any): void {
    this.objective = content.objective;
    this.userInfo = content.userInfo;

    switch (this.userInfo.language) {
      case 'en':
        defineLocale(this.userInfo.language, enGbLocale);
        break;
      case 'it':
        // enGbLocale.invalidDate = 'Custom label';
        defineLocale(this.userInfo.language, itLocale);
        break;
      case 'pt':
        defineLocale(this.userInfo.language, ptBrLocale);
        break;
      case 'es':
        defineLocale(this.userInfo.language, esLocale);
        break;
      case 'fr':
        defineLocale(this.userInfo.language, frLocale);
        break;
      case 'pl':
        defineLocale(this.userInfo.language, plLocale);
        break;
      case 'de':
        defineLocale(this.userInfo.language, deLocale);
        break;
      case 'ru':
        defineLocale(this.userInfo.language, ruLocale);
        break;
      case 'nl':
        defineLocale(this.userInfo.language, nlLocale);
        break;
      case 'ar':
        defineLocale(this.userInfo.language, arLocale);
        break;
      case 'zh':
        defineLocale(this.userInfo.language, zhCnLocale);
        break;
    }
    this.localeService.use(this.userInfo.language);

    this.amsd_settings_cycles = {
      text: this.coreService.getTranslation(
        'OBJECTIVE_SHEET_POPUP.NoCycleSelected'
      ),
      selectAllText: '',
      unSelectAllText: '',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: 'amsdDropdown regular',
      showCheckbox: false,
      singleSelection: true,
      position: 'bottom',
      autoPosition: false
    };

    this.companyReportService
      .getDeferredCycles(this.objective.Id)
      .subscribe((cycleList: any) => {
        if (cycleList && cycleList.length > 0) {
          this.cycleList = [];
          cycleList.forEach((cycle: any) => {
            cycle.id = cycle.Id;
            cycle.itemName = cycle.Name;
            this.cycleList.push(cycle);
          });
        }
      });
  }

  getdpConfig() {
    this.dpConfig.adaptivePosition = true;
    this.dpConfig.dateInputFormat = 'DD/MM/YYYY';
    this.dpConfig.displayOneMonthRange = true;
    this.userInfo?.language === 'it' ? 'D MMM, YYYY' : 'MMM D, YYYY';
    this.dpConfig.containerClass = 'magda_datepicker_theme_123 emp-dialog';
    this.dpConfig.customTodayClass = 'custom-today-class';
    this.dpConfig.useUtc = true;
    this.dpConfig.showWeekNumbers = false;
    return this.dpConfig;
  }

  deferring: boolean = false;
  public onConfirm() {
    this.deferring = true;
    this.onClose.next({
      deferr: true,
      DueDate: this.deferDueDate,
      DeferralType: this.deferralType,
      selectedCycleId: this.selectedCycle.id
        ? this.selectedCycle.id
        : this.selectedCycle[0]?.Id
    });
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next({ deferr: false });
    this._bsModalRef.hide();
  }

  onSelectCycle(event: any) {
    this.selectedCycle = event;
    this.deferDueDate = moment(new Date(event.EndDate)).format(
      'YYYY-MM-DDThh:mm:ss'
    );
  }

  changeDeferChange(deferType: string) {
    this.deferralType = deferType;
  }
}
